import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";


export type IDialogInfo = {
    visible: boolean,
    text : string
};

/**
 * @author noone
 */

export type DialogState = {
    loginVisible: boolean,
    createAccountVisible: boolean,
    ctaSubscriptionVisible: boolean
    sendRegistrationMailVisible: boolean
    mailRegisteredVisible: boolean,
    passwordResetVisible: boolean,
    passwordResetMailVisible: boolean,
    createNewPasswordVisible: boolean,
    createNewPasswordConfirmedVisible: boolean,
    modalMessageOkDialogVisible: IDialogInfo,
}

const initialState = {
    loginVisible: false,
    createAccountVisible: false,
    ctaSubscriptionVisible: false,
    sendRegistrationMailVisible: false,
    mailRegisteredVisible: false,
    passwordResetVisible: false,
    passwordResetMailVisible: false,
    createNewPasswordVisible: false,
    createNewPasswordConfirmedVisible: false,
    modalMessageOkDialogVisible: { visible: false, text: ''},
} as DialogState;

const dialogSlice = createSlice({
    name: 'dialog',
    initialState: initialState,
    reducers: {
        setLoginVisible(state, action: PayloadAction<boolean>) {
            state.loginVisible = action.payload;
        },
        setCreateAccountVisible(state, action: PayloadAction<boolean>) {
            state.createAccountVisible = action.payload;
        },
        setCTASubscriptionVisible(state, action: PayloadAction<boolean>) {
            state.ctaSubscriptionVisible = action.payload;
        },
        setSendRegistrationMailVisible(state, action: PayloadAction<boolean>) {
            state.sendRegistrationMailVisible = action.payload;
        },
        setDialogMailRegisteredVisible(state, action: PayloadAction<boolean>) {
            state.mailRegisteredVisible = action.payload;
        },
        setDialogPasswordResetVisible(state, action: PayloadAction<boolean>) {
            state.passwordResetVisible = action.payload;
        },
        setDialogPasswordResetMailVisible(state, action: PayloadAction<boolean>) {
            state.passwordResetMailVisible = action.payload;
        },
        setDialogCreateNewPasswordVisible(state, action: PayloadAction<boolean>) {
            state.createNewPasswordVisible = action.payload;
        },
        setDialogCreateNewPasswordConfirmedVisible(state, action: PayloadAction<boolean>) {
            state.createNewPasswordConfirmedVisible = action.payload;
        },
        setModalMessageOkDialogVisible(state, action: PayloadAction<IDialogInfo>) {
            state.modalMessageOkDialogVisible = action.payload;
        },

    }
});

export const {
    setLoginVisible
    , setCreateAccountVisible
    , setCTASubscriptionVisible
    , setSendRegistrationMailVisible
    , setDialogMailRegisteredVisible
    , setDialogPasswordResetVisible
    , setDialogPasswordResetMailVisible
    , setDialogCreateNewPasswordVisible
    , setDialogCreateNewPasswordConfirmedVisible
    , setModalMessageOkDialogVisible

} = dialogSlice.actions;

export default dialogSlice;


